import { Injectable } from '@angular/core';
import { NgEntityService, NgEntityServiceConfig } from '@datorama/akita-ng-entity-service';
import { Guid } from 'guid-typescript';
import { catchError, finalize, tap } from 'rxjs/operators';
import { handleHttpRequest } from 'src/app/shared';
import { CsProject } from './cs-project.model';
import { CsProjectState, CsProjectStore } from './cs-project.store';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
@NgEntityServiceConfig({
  resourceName: 'projects'
})
export class CsProjectsService extends NgEntityService<CsProjectState> {
  constructor(protected csProjectsStore: CsProjectStore, private readonly snackBar: MatSnackBar) {
                super(csProjectsStore);
  }

  copyProject(projectId: Guid): Observable<CsProject> {
    const url = `${this.baseUrl}/${this.resourceName}/${projectId.toString()}`
    return this
      .getHttp()
      .post<CsProject>(url, null, { responseType: 'json' })
      .pipe(
        handleHttpRequest(),
        tap(clonedProject => this.store.add(clonedProject)),
        catchError(error => {
          this.snackBar.open('Es ist ein Fehler aufgetreten. Bitte versuchen sie es später noch ein mal.', undefined,
          {
            politeness: 'assertive',
            duration: 5000,
            verticalPosition: 'top',
          });
          throw error;
        }));
  }
}
